import { auth, role } from './privateRoute.service';
import Storage from '../../classes/Storage/Storage';
import CustomError from '../../classes/CustomError/CustomError';
import { useEffect, useState } from 'react';
import Session from '../../classes/Session/Session';
import Translator from '../../classes/Translator/Translator';

const PrivateRouteLogic = ({ allowedRoles = [] }) => {
  const [state, setState] = useState('loading');
  const [isValidRole, setIsValidRole] = useState(true);
  const { translator } = Translator();

  const checkRole = async () => {
    if (!allowedRoles.length) {
      setIsValidRole(true);
      return;
    }

    const roleObject = await role();

    const roles = roleObject?.role || [];

    setIsValidRole(
      allowedRoles.some((allowedRole) => roles.includes(allowedRole))
    );
  };

  useEffect(() => {
    (async function () {
      try {
        const isTokenStored = new Storage('token').getItem();
        const authInAPI = await auth();
        await checkRole();
        const isUserAuth = isTokenStored && !(authInAPI instanceof CustomError);
        if (!isUserAuth) {
          await new Session({}).logout();
        }
        setState(isUserAuth ? 'logged' : 'redirect');
      } catch (error) {
        await new Session({}).logout();
        setState('redirect');
      }
    })();
  }, []);

  return {
    state,
    isValidRole,
    translator,
  };
};

export default PrivateRouteLogic;
